import React, {useState, Fragment} from 'react';
import Target from "./Target";


export const RagStatusValues = {
	UNSET: 0,
	RED: 1 ,
	AMBER: 2,
	GREEN: 3,
}

const RAGStatus = ({ value, onChange } ) =>
{
	const [ status, setStatus ] = useState( +value ) ;

	const onClick = ( value ) =>
	{
		if ( onChange != null)
		{
			onChange ( value );

			setStatus ( value ) ;
		}
	}

	const icon = ( value ) =>
	{
		const colors = { 1: '#DB1415', 2: '#FF9800', 3: '#017B01' } ;

		const iconColor = status === value ? colors[value] : 'lightgrey' ;

		let style = { fontSize: 'large', color: iconColor, marginRight: '0px', display: 'inline' } ;

		if ( onChange !== null )
		{
			style = { ...style, cursor: 'pointer' };
		}

		let iconProps = {  key: 'key' + value, style: style }  ;

		if ( onChange !== null )
		{
			iconProps = { ...iconProps, onClick: () => onClick ( value ) } ;
		}

		return (
			<div {...iconProps }><Target color={iconColor} size='20px'/></div>
		)
	}

	return (
		<Fragment>
			{ icon (  1)}
			{ icon (  2)}
			{ icon (  3)}
		</Fragment>
	)
}

export default RAGStatus ;
